/* unplugin-vue-components disabled */import { render } from "./MenuDetails.vue?vue&type=template&id=5fbf5197&scoped=true"
import script from "./MenuDetails.vue?vue&type=script&lang=js"
export * from "./MenuDetails.vue?vue&type=script&lang=js"

import "./MenuDetails.vue?vue&type=style&index=0&id=5fbf5197&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbf5197"]])

export default __exports__